module.exports = __webpack_public_path__ + "img/cissa-logo-white.5c5301f5.png";